import { classNameMerger } from '@breetometer/utils';

import BreadCrumbs from './BreadCrumb';

export const SettingsWrapper = ({
	children,
	isSub,
	breadCrumb,
}: {
	children: React.ReactNode;
	isSub?: boolean;
	breadCrumb?: boolean;
}) => (
	<div className='bodycontent-wrapper'>
		<div className={classNameMerger('child', isSub && 'sub-body')}>
			{breadCrumb && <BreadCrumbs noHome />}
			{children}
		</div>
	</div>
);
